export default {
  "rowSelection": false,
  "fieldControl": false,
  "columns": [
    {
      "title": "门店",
      "dataIndex": "companyName",
      "render": "companyNameRender",
      "width": 200,
    },
    {
      "title": "承包商",
      "dataIndex": "vendorName",
      "width": 200,
    },
    {
      "title": "姓名",
      "dataIndex": "extEmpName",
      "width": 100,
      ellipsis: true
    },
    {
      "title": "技能标签",
      "dataIndex": "postName",
      "width": 200,
      ellipsis: true
    },
    {
      "title": "财务主体",
      "dataIndex": "fmsCompanyName",
      "width": 200,
    },
    {
      "title": "电话",
      "dataIndex": "phone",
      "width": 200
    },
    {
      "title": "身份证",
      "dataIndex": "idCard",
      "width": 200
    },
    {
      "title": "入职日期",
      "dataIndex": "joinDate",
      "itemType": "date",
      "width": 200
    },
    {
      "title": "人员状态",
      "dataIndex": "actStatusName",
      "width": 100
    },
    {
      "title": "质保金余额(元)",
      "dataIndex": "accountBalance",
      "render": "setAccountBalance",
      "width": 140
    },
    {
      "title": "支出冻结金额(元)",
      "dataIndex": "payFrozenAmount",
      "render": "setFrozenAmount",
      "width": 160
    },
    {
      "title": "收入冻结金额(元)",
      "dataIndex": "incFrozenAmount",
      "render": "setIncomeFreezeAmount",
      "width": 160
    },
    {
      "title": "可用金额(元)",
      "dataIndex": "availableAmount",
      "render": "setAvailableAmount",
      "width": 140
    },
    {
      "title": "是否实退",
      "dataIndex": "isRefund",
      "render": "setIsRefund",
      "width": 100
    }
  ],
  "search": [
    {
      "name": "extEmpNameOrPhone",
      "label": "姓名/电话"
    },

    {
      "name": "idCard",
      "label": "身份证"
    },
    {
      "name": "companyIds",
      "label": "门店",
      "itemType": "custom",
      "render": "setCompany"
    },
    {
      name: "fmsCompanyId",
      label: "财务主体",
      "itemType": "custom",
      render: "setEsigncompany"
    }

  ],
  "footer": [
    {
      "label": "导出",
      "auth": "retentionMoneyManagementAccountListExport",
      "events": [
        "onClick:onExport"
      ],
      "status": [
        "loading:exportLoading"
      ]
    },
    {
      "label": "补充生成账户",
      "type": "primary",
      "auth": "addAccount",
      "events": ["onClick:onAdd"]
    }
  ]
}
